import React from 'react';
import Link, { LinkProps } from 'next/link';
import { DestinationLinkBuilder } from '@model/iceberg/geography';
import { Keyable, TripTypes } from '@model/common';
import { TestId } from '@components/test-ids';
import { PlainLinkStyles } from '@styles/common';

export interface TourLinkProps {
  path: string;
  children?: JSX.Element | string;
  tripType?: TripTypes;
  onMouseDown?: (event: any) => void;
  search?: Keyable;
}

export const TourLink = ({ path, children, tripType, onMouseDown, search }: TourLinkProps) => {
  const linkBuilder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const link: LinkProps = linkBuilder.getTourLink(path, tripType, search);
  return path ? (
    <Link
      prefetch={false}
      {...link}
      passHref
      css={PlainLinkStyles}
      data-testid={TestId.tourLink}
      onMouseDown={onMouseDown}
    >
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
};
